import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-2" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group position-relative" }
const _hoisted_9 = {
  key: 0,
  class: "col"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "py-sm-1 d-block" }
const _hoisted_12 = {
  key: 1,
  class: "col"
}
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "form-group position-relative" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "form-group position-relative" }

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'RequisitionFilter',
  props: {
  link: {
    type: Object,
    default: null,
  },
  statusFilter: {
    type: Boolean,
    default: true,
  }
},
  emits: ["searchByQuery"],
  setup(__props, { emit: __emit }) {

const sortby = ref("");
const search = ref("");
const requisitionStatus = ref("");
const requisitionPriority = ref("");
const listRequisitionStatus = [
  { value: "", label: "All Status" },
  { value: "1", label: "Draft" },
  { value: "2", label: "Waiting Approval" },
  { value: "3", label: "Approved" },
  { value: "4", label: "Revision" },
  { value: "5", label: "Declined" },
  { value: "6", label: "Completed" },
];
const listRequisitionPriority = [
  { value: "", label: "All Priority" },
  { value: "1", label: "Regular" },
  { value: "2", label: "Urgent" },
];

const props = __props;

const emit = __emit;

const buildQuery = () => {
  let queryTemp = "";
  if (search.value != "") {
    queryTemp = queryTemp + "&keyword=" + search.value.toLocaleLowerCase();
  }

  if (sortby.value != "") {
    queryTemp = queryTemp + "&sort_by=" + sortby.value.toLocaleLowerCase();
  }

  if (requisitionStatus.value != "") {
    if (requisitionStatus.value?.value != 0) {
      queryTemp =
        queryTemp + "&requisition_status_id=" + requisitionStatus.value?.value;
    }
  }

  if (requisitionPriority.value != "") {
    if (requisitionPriority.value?.value != 0) {
      queryTemp =
        queryTemp + "&priority=" + requisitionPriority.value?.value;
    }
  }

  emit("searchByQuery", queryTemp);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
              onKeyup: buildQuery,
              placeholder: "Search here....."
            }, null, 544), [
              [_vModelText, search.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_unref(vSelect), {
                modelValue: sortby.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sortby).value = $event)),
                options: ['Name', 'Date'],
                placeholder: "Sort By",
                onClose: buildQuery
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        (props?.link != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("a", {
                class: "btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg",
                href: props?.link?.url
              }, [
                _createElementVNode("span", _hoisted_11, [
                  _cache[4] || (_cache[4] = _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block me-1" }, null, -1)),
                  _createElementVNode("span", null, _toDisplayString(props?.link?.text), 1)
                ])
              ], 8, _hoisted_10)
            ]))
          : _createCommentVNode("", true),
        (props.statusFilter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_unref(vSelect), {
                    modelValue: requisitionStatus.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((requisitionStatus).value = $event)),
                    options: listRequisitionStatus,
                    placeholder: "Status",
                    onClose: buildQuery
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_unref(vSelect), {
                modelValue: requisitionPriority.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((requisitionPriority).value = $event)),
                options: listRequisitionPriority,
                placeholder: "Priority",
                onClose: buildQuery
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})